import React from "react";

export default () => {
  return (
    <footer className="text-white mt-5 p-2 navbar-custom text-center" style={{ fontSize: "9pt" }}>
      Copyright &copy; {new Date().getFullYear()} Lodging Deals
    </footer>
  );
};



// WEBPACK FOOTER //
// ./src/components/layout/Footer.js